module.exports = __webpack_public_path__ + "static/9-fc6ab36012a174bd64a52c791a1b1865.png";